import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-3 bg-white/10 rounded-b-xl pb-3"
}
const _hoisted_2 = ["size"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["input bg-white/10 backdrop-blur px-2 py-3 mt-4", $setup.data.results.length > 0 ? 'rounded-t-xl' : 'rounded-xl'])
    }, [
      _withDirectives(_createElementVNode("input", {
        maxlength: "25",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.category) = $event)),
        onFocusout: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleFocusOut && $setup.handleFocusOut(...args))),
        onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.onEnter && $setup.onEnter(...args))),
        type: "text",
        id: "tags",
        ref: "inputTags",
        class: "w-full text-sm rounded-base border-transparent outline-none focus:border-transparent focus:ring-0",
        placeholder: "Tags"
      }, null, 544), [
        [_vModelText, $setup.data.category]
      ]),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.addTag && $setup.addTag(...args))),
        type: "button",
        class: "absolute end-1.5 bottom-2 text-white hover:bg-brand-strong shadow-xs font-medium leading-5 rounded text-xs px-3 py-1.5 focus:outline-none hover:bg-white/10"
      }, "+")
    ], 2),
    ($setup.data.results.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-sm font-medium ms-2 pb-1" }, "Suggested Categories", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.dummy) = $event)),
            size: $setup.data.results.length < 5 ? $setup.data.results.length + 1 : 4,
            class: "w-full pb-1 px-2 bg-white/10 rounded-lg text-sm border border-white/20 focus:outline-none focus:ring-2 focus:ring-white-400"
          }, [
            _cache[5] || (_cache[5] = _createElementVNode("option", {
              disabled: "",
              value: "a"
            }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.results, (result) => {
              return (_openBlock(), _createElementBlock("option", {
                class: "pb-1",
                selected: "false",
                onClick: ($event: any) => ($setup.selectResult(result)),
                key: result
              }, _toDisplayString(result), 9, _hoisted_3))
            }), 128))
          ], 8, _hoisted_2), [
            [_vModelSelect, $setup.data.dummy]
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.tags, (value, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "flex float-left px-2 py-1 me-2 mb-2 bg-blue-300 text-black rounded"
        }, [
          _createElementVNode("span", null, _toDisplayString(value), 1),
          _createElementVNode("span", {
            class: "m-auto ms-1 rounded hover:bg-white",
            onClick: ($event: any) => ($setup.removeTag(index))
          }, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "16",
              height: "16",
              fill: "currentColor",
              class: "bi bi-x",
              viewBox: "0 0 16 16"
            }, [
              _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
            ], -1)
          ]))], 8, _hoisted_5)
        ]))
      }), 128))
    ])
  ], 64))
}